export class MediaService {
    public static getMediaUrl(mediaFileId: number | string): string {
        return window.appGlobals.PART_IMAGES_API_URL + "Media/FileById?id=" + mediaFileId;
    }
}